
export default {
  name: "accountCard",
};
